<div class="xr-page fm-page">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ 'filemanager.ui.page_title' | translate }}</h1>
    </div>
    <app-company-filter mode="documents"></app-company-filter>
  </header>

  @if (view === 'home') {
    <app-documents-home (openFolder)="browse($event)" (browseAll)="browse()"></app-documents-home>
  } @else {
    <div>
      <button type="button" class="xr-btn xr-btn--secondary" (click)="showHome()">
        <i-tabler name="arrow-left" class="icon-18" aria-hidden="true"></i-tabler>
        {{ 'filemanager.home.back' | translate }}
      </button>
    </div>
    <!-- albero cartelle + contenuto (libreria filemanager-explorer) -->
    <div class="fm-body">
      <nxe-explorer [showSwitcher]="true" [showEditFile]="true"></nxe-explorer>
    </div>
  }
</div>
